import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery, getOrganizationBySlug, getTenants } from 'wasp/client/operations';
import { DashboardLayout } from '../../../client/components/Sidebar';
import { DirectoryEntriesTable } from '../../../components/ui/directory-entries-table';
import { Building2 } from 'lucide-react';

export default function OrgTenantsPage() {
  const { slug } = useParams<{ slug: string }>();
  const { data: org, isLoading: orgLoading } = useQuery(getOrganizationBySlug, { slug: slug! }) as { data: any; isLoading: boolean };

  const { data: tenants = [], isLoading: tenantsLoading } = useQuery(
    getTenants,
    { organizationId: org?.id },
    { enabled: !!org?.id }
  ) as { data: any[]; isLoading: boolean };

  const entries = tenants.map((tenant: any) => ({
    id: tenant.id,
    title: tenant.companyName,
    description: tenant.description,
    category: tenant.category ?? null,
  }));

  return (
    <DashboardLayout>
      <div className="flex items-center justify-between px-6 py-4 border-b border-border">
        <h1 className="text-2xl font-bold text-gray-900">Tenants</h1>
      </div>

      {(orgLoading || tenantsLoading) && (
        <div className="flex items-center justify-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
        </div>
      )}

      {!orgLoading && !tenantsLoading && tenants.length === 0 && (
        <div className="text-center py-12 text-gray-500">
          <Building2 className="w-12 h-12 mx-auto mb-3 opacity-30" />
          <p>No tenants for this organization yet.</p>
        </div>
      )}

      {!orgLoading && !tenantsLoading && tenants.length > 0 && (
        <DirectoryEntriesTable entries={entries} />
      )}
    </DashboardLayout>
  );
}
